import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import authService from './services/authService.js'
// @ts-ignore
import API_BASE_URL from './config/apiConfig'

// Expose API_BASE_URL to window for use in vanilla JS
// @ts-ignore
window.API_BASE_URL = API_BASE_URL;

// Disable browser scroll restoration globally
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

authService.setupInterceptors()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
